import { action } from "satcheljs";

interface ComposePlainTextContentInsertedActionMessage {
    composeId: string;
    changeSource: string;
}

const composePlainTextContentInserted: (composeId: string, changeSource: string) => ComposePlainTextContentInsertedActionMessage = action("composePlainTextContentInserted", (composeId: string, changeSource: string): ComposePlainTextContentInsertedActionMessage => ({
    composeId,
    changeSource,
}));

export default composePlainTextContentInserted;
